import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue'
import { AlertsData, AlertsIcons } from '@/store/modules/alerts/alertsTypes'


export default /*#__PURE__*/_defineComponent({
  __name: 'StaticAlertComponent',
  props: {
  alert: {
    type: Object as PropType<AlertsData>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const showStaticAlert = ref(true)

const closeStaticAlert = () => {
  showStaticAlert.value = false
}

const getAlertType = computed(() => props.alert.type)

const getAlertIcon = computed(() => {
  return AlertsIcons[props.alert.type]
})

return { __sfc: true,props, showStaticAlert, closeStaticAlert, getAlertType, getAlertIcon }
}

})